import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDate: string;
  AWSDateTime: string;
  AWSEmail: string;
  AWSIPAddress: string;
  AWSJSON: string;
  AWSTime: string;
  AWSTimestamp: number;
  AWSURL: string;
};

export type Cluster = {
  __typename?: 'Cluster';
  bounds?: Maybe<ClusterBounds>;
  count?: Maybe<Scalars['Int']>;
  listing?: Maybe<ClusterListing>;
  location?: Maybe<ClusterLocation>;
  map?: Maybe<Array<Maybe<Array<Maybe<Array<Maybe<Scalars['String']>>>>>>>;
};

export type ClusterBounds = {
  __typename?: 'ClusterBounds';
  bottom_right?: Maybe<ClusterBoundsPoint>;
  top_left?: Maybe<ClusterBoundsPoint>;
};

export type ClusterBoundsPoint = {
  __typename?: 'ClusterBoundsPoint';
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
};

export type ClusterListing = {
  __typename?: 'ClusterListing';
  mlsNumber?: Maybe<Scalars['String']>;
};

export type ClusterLocation = {
  __typename?: 'ClusterLocation';
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
};

export type Listing = {
  __typename?: 'Listing';
  address?: Maybe<ListingAddress>;
  class?: Maybe<Scalars['String']>;
  condominium?: Maybe<ListingCondominium>;
  details: ListingDetails;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  listPrice: Scalars['String'];
  lot?: Maybe<Lot>;
  map: ListingMap;
  mlsNumber: Scalars['String'];
  office?: Maybe<OfficeInfo>;
  taxes?: Maybe<Taxes>;
  timestamps?: Maybe<Timestamps>;
  type?: Maybe<Scalars['String']>;
};

export type ListingAddress = {
  __typename?: 'ListingAddress';
  city?: Maybe<Scalars['String']>;
  neighborhood?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type ListingCondominium = {
  __typename?: 'ListingCondominium';
  stories?: Maybe<Scalars['String']>;
};

export type ListingDetails = {
  __typename?: 'ListingDetails';
  basement1?: Maybe<Scalars['String']>;
  basement2?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  garage?: Maybe<Scalars['String']>;
  heating?: Maybe<Scalars['String']>;
  moreInformationLink?: Maybe<Scalars['String']>;
  numBathrooms?: Maybe<Scalars['String']>;
  numBedrooms?: Maybe<Scalars['String']>;
  numParkingSpaces?: Maybe<Scalars['String']>;
  numRooms?: Maybe<Scalars['String']>;
  parkingType?: Maybe<Scalars['String']>;
  roofMaterial?: Maybe<Scalars['String']>;
  sqft?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  yearBuilt?: Maybe<Scalars['String']>;
};

export type ListingMap = {
  __typename?: 'ListingMap';
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  point?: Maybe<Scalars['String']>;
};

export type ListingResults = {
  __typename?: 'ListingResults';
  clusterPrecision?: Maybe<Scalars['Int']>;
  clusters?: Maybe<Array<Maybe<Cluster>>>;
  count?: Maybe<Scalars['Int']>;
  listings?: Maybe<Array<Maybe<Listing>>>;
  map?: Maybe<Scalars['String']>;
  numPages?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
};

export type Lot = {
  __typename?: 'Lot';
  acres?: Maybe<Scalars['String']>;
};

export type OfficeInfo = {
  __typename?: 'OfficeInfo';
  brokerageName?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  getListing?: Maybe<Listing>;
  getSitemap?: Maybe<Scalars['String']>;
  searchListings?: Maybe<ListingResults>;
  similarListings?: Maybe<Array<Listing>>;
};


export type QueryGetListingArgs = {
  clientIp?: InputMaybe<Scalars['String']>;
  mlsNumber: Scalars['String'];
};


export type QuerySearchListingsArgs = {
  clientIp?: InputMaybe<Scalars['String']>;
  filterValues?: InputMaybe<SearchListingsFilterValues>;
};


export type QuerySimilarListingsArgs = {
  clientIp?: InputMaybe<Scalars['String']>;
  mlsNumber: Scalars['String'];
};

export type SearchListingsFilterValues = {
  boundary?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  fastSearch?: InputMaybe<Scalars['Boolean']>;
  hasImages?: InputMaybe<Scalars['Boolean']>;
  maxPrice?: InputMaybe<Scalars['String']>;
  maximumMonthlyPayment?: InputMaybe<Scalars['String']>;
  minBaths?: InputMaybe<Scalars['String']>;
  minBeds?: InputMaybe<Scalars['String']>;
  minListDate?: InputMaybe<Scalars['String']>;
  minPrice?: InputMaybe<Scalars['String']>;
  minimumMonthlyPayment?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sqft?: InputMaybe<Scalars['String']>;
  yearBuilt?: InputMaybe<Scalars['String']>;
};

export type Taxes = {
  __typename?: 'Taxes';
  annualAmount?: Maybe<Scalars['String']>;
  assessmentYear?: Maybe<Scalars['String']>;
};

export type Timestamps = {
  __typename?: 'Timestamps';
  listingEntryDate?: Maybe<Scalars['String']>;
  listingUpdated?: Maybe<Scalars['String']>;
};

export type GetListingQueryVariables = Exact<{
  mlsNumber: Scalars['String'];
  clientIp?: InputMaybe<Scalars['String']>;
}>;


export type GetListingQuery = { __typename?: 'Query', getListing?: { __typename?: 'Listing', images?: Array<string | null> | null, listPrice: string, mlsNumber: string, type?: string | null, class?: string | null, address?: { __typename?: 'ListingAddress', city?: string | null, neighborhood?: string | null, streetName?: string | null, streetNumber?: string | null, zip?: string | null, state?: string | null } | null, details: { __typename?: 'ListingDetails', description?: string | null, garage?: string | null, moreInformationLink?: string | null, heating?: string | null, numRooms?: string | null, numBathrooms?: string | null, numParkingSpaces?: string | null, numBedrooms?: string | null, parkingType?: string | null, sqft?: string | null, yearBuilt?: string | null, roofMaterial?: string | null, basement1?: string | null, basement2?: string | null, style?: string | null }, lot?: { __typename?: 'Lot', acres?: string | null } | null, map: { __typename?: 'ListingMap', latitude?: string | null, longitude?: string | null, point?: string | null }, timestamps?: { __typename?: 'Timestamps', listingEntryDate?: string | null, listingUpdated?: string | null } | null, taxes?: { __typename?: 'Taxes', annualAmount?: string | null, assessmentYear?: string | null } | null, condominium?: { __typename?: 'ListingCondominium', stories?: string | null } | null, office?: { __typename?: 'OfficeInfo', brokerageName?: string | null } | null } | null };

export type GetSimilarListingsQueryVariables = Exact<{
  mlsNumber: Scalars['String'];
  clientIp?: InputMaybe<Scalars['String']>;
}>;


export type GetSimilarListingsQuery = { __typename?: 'Query', similarListings?: Array<{ __typename?: 'Listing', mlsNumber: string, type?: string | null, class?: string | null, listPrice: string, images?: Array<string | null> | null, map: { __typename?: 'ListingMap', latitude?: string | null, longitude?: string | null, point?: string | null }, address?: { __typename?: 'ListingAddress', streetName?: string | null, streetNumber?: string | null, city?: string | null, state?: string | null } | null, details: { __typename?: 'ListingDetails', description?: string | null, garage?: string | null, moreInformationLink?: string | null, heating?: string | null, numBathrooms?: string | null, numParkingSpaces?: string | null, numBedrooms?: string | null, parkingType?: string | null, sqft?: string | null, yearBuilt?: string | null, roofMaterial?: string | null } }> | null };

export type GetSitemapQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSitemapQuery = { __typename?: 'Query', getSitemap?: string | null };

export type SearchListingsQueryVariables = Exact<{
  filterValues?: InputMaybe<SearchListingsFilterValues>;
  clientIp?: InputMaybe<Scalars['String']>;
}>;


export type SearchListingsQuery = { __typename?: 'Query', searchListings?: { __typename?: 'ListingResults', count?: number | null, page?: number | null, numPages?: number | null, pageSize?: number | null, clusterPrecision?: number | null, map?: string | null, clusters?: Array<{ __typename?: 'Cluster', count?: number | null, map?: Array<Array<Array<string | null> | null> | null> | null, location?: { __typename?: 'ClusterLocation', latitude?: string | null, longitude?: string | null } | null, bounds?: { __typename?: 'ClusterBounds', bottom_right?: { __typename?: 'ClusterBoundsPoint', latitude?: string | null, longitude?: string | null } | null, top_left?: { __typename?: 'ClusterBoundsPoint', latitude?: string | null, longitude?: string | null } | null } | null, listing?: { __typename?: 'ClusterListing', mlsNumber?: string | null } | null } | null> | null, listings?: Array<{ __typename?: 'Listing', mlsNumber: string, type?: string | null, class?: string | null, listPrice: string, images?: Array<string | null> | null, map: { __typename?: 'ListingMap', latitude?: string | null, longitude?: string | null, point?: string | null }, address?: { __typename?: 'ListingAddress', streetName?: string | null, streetNumber?: string | null, city?: string | null, state?: string | null } | null, details: { __typename?: 'ListingDetails', numBathrooms?: string | null, numBedrooms?: string | null } } | null> | null } | null };


export const GetListingDocument = gql`
    query GetListing($mlsNumber: String!, $clientIp: String) {
  getListing(mlsNumber: $mlsNumber, clientIp: $clientIp) {
    address {
      city
      neighborhood
      streetName
      streetNumber
      zip
      state
    }
    details {
      description
      garage
      moreInformationLink
      heating
      numRooms
      numBathrooms
      numParkingSpaces
      numBedrooms
      parkingType
      sqft
      yearBuilt
      roofMaterial
      basement1
      basement2
      style
    }
    images
    listPrice
    lot {
      acres
    }
    map {
      latitude
      longitude
      point
    }
    mlsNumber
    type
    class
    timestamps {
      listingEntryDate
      listingUpdated
    }
    taxes {
      annualAmount
      assessmentYear
    }
    condominium {
      stories
    }
    office {
      brokerageName
    }
  }
}
    `;

/**
 * __useGetListingQuery__
 *
 * To run a query within a React component, call `useGetListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingQuery({
 *   variables: {
 *      mlsNumber: // value for 'mlsNumber'
 *      clientIp: // value for 'clientIp'
 *   },
 * });
 */
export function useGetListingQuery(baseOptions: Apollo.QueryHookOptions<GetListingQuery, GetListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListingQuery, GetListingQueryVariables>(GetListingDocument, options);
      }
export function useGetListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListingQuery, GetListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListingQuery, GetListingQueryVariables>(GetListingDocument, options);
        }
export type GetListingQueryHookResult = ReturnType<typeof useGetListingQuery>;
export type GetListingLazyQueryHookResult = ReturnType<typeof useGetListingLazyQuery>;
export type GetListingQueryResult = Apollo.QueryResult<GetListingQuery, GetListingQueryVariables>;
export const GetSimilarListingsDocument = gql`
    query GetSimilarListings($mlsNumber: String!, $clientIp: String) {
  similarListings(mlsNumber: $mlsNumber, clientIp: $clientIp) {
    mlsNumber
    type
    class
    listPrice
    images
    map {
      latitude
      longitude
      point
    }
    address {
      streetName
      streetNumber
    }
    details {
      description
      garage
      moreInformationLink
      heating
      numBathrooms
      numParkingSpaces
      numBedrooms
      parkingType
      sqft
      yearBuilt
      roofMaterial
    }
    address {
      city
      state
    }
  }
}
    `;

/**
 * __useGetSimilarListingsQuery__
 *
 * To run a query within a React component, call `useGetSimilarListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimilarListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimilarListingsQuery({
 *   variables: {
 *      mlsNumber: // value for 'mlsNumber'
 *      clientIp: // value for 'clientIp'
 *   },
 * });
 */
export function useGetSimilarListingsQuery(baseOptions: Apollo.QueryHookOptions<GetSimilarListingsQuery, GetSimilarListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimilarListingsQuery, GetSimilarListingsQueryVariables>(GetSimilarListingsDocument, options);
      }
export function useGetSimilarListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimilarListingsQuery, GetSimilarListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimilarListingsQuery, GetSimilarListingsQueryVariables>(GetSimilarListingsDocument, options);
        }
export type GetSimilarListingsQueryHookResult = ReturnType<typeof useGetSimilarListingsQuery>;
export type GetSimilarListingsLazyQueryHookResult = ReturnType<typeof useGetSimilarListingsLazyQuery>;
export type GetSimilarListingsQueryResult = Apollo.QueryResult<GetSimilarListingsQuery, GetSimilarListingsQueryVariables>;
export const GetSitemapDocument = gql`
    query GetSitemap {
  getSitemap
}
    `;

/**
 * __useGetSitemapQuery__
 *
 * To run a query within a React component, call `useGetSitemapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSitemapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSitemapQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSitemapQuery(baseOptions?: Apollo.QueryHookOptions<GetSitemapQuery, GetSitemapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSitemapQuery, GetSitemapQueryVariables>(GetSitemapDocument, options);
      }
export function useGetSitemapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSitemapQuery, GetSitemapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSitemapQuery, GetSitemapQueryVariables>(GetSitemapDocument, options);
        }
export type GetSitemapQueryHookResult = ReturnType<typeof useGetSitemapQuery>;
export type GetSitemapLazyQueryHookResult = ReturnType<typeof useGetSitemapLazyQuery>;
export type GetSitemapQueryResult = Apollo.QueryResult<GetSitemapQuery, GetSitemapQueryVariables>;
export const SearchListingsDocument = gql`
    query SearchListings($filterValues: SearchListingsFilterValues, $clientIp: String) {
  searchListings(filterValues: $filterValues, clientIp: $clientIp) {
    count
    page
    numPages
    pageSize
    clusterPrecision
    map
    clusters {
      count
      location {
        latitude
        longitude
      }
      bounds {
        bottom_right {
          latitude
          longitude
        }
        top_left {
          latitude
          longitude
        }
      }
      map
      listing {
        mlsNumber
      }
    }
    listings {
      mlsNumber
      type
      class
      listPrice
      images
      map {
        latitude
        longitude
        point
      }
      address {
        streetName
        streetNumber
        city
        state
      }
      details {
        numBathrooms
        numBedrooms
      }
    }
  }
}
    `;

/**
 * __useSearchListingsQuery__
 *
 * To run a query within a React component, call `useSearchListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchListingsQuery({
 *   variables: {
 *      filterValues: // value for 'filterValues'
 *      clientIp: // value for 'clientIp'
 *   },
 * });
 */
export function useSearchListingsQuery(baseOptions?: Apollo.QueryHookOptions<SearchListingsQuery, SearchListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchListingsQuery, SearchListingsQueryVariables>(SearchListingsDocument, options);
      }
export function useSearchListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchListingsQuery, SearchListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchListingsQuery, SearchListingsQueryVariables>(SearchListingsDocument, options);
        }
export type SearchListingsQueryHookResult = ReturnType<typeof useSearchListingsQuery>;
export type SearchListingsLazyQueryHookResult = ReturnType<typeof useSearchListingsLazyQuery>;
export type SearchListingsQueryResult = Apollo.QueryResult<SearchListingsQuery, SearchListingsQueryVariables>;
export const namedOperations = {
  Query: {
    GetListing: 'GetListing',
    GetSimilarListings: 'GetSimilarListings',
    GetSitemap: 'GetSitemap',
    SearchListings: 'SearchListings'
  }
}